import { ResultsRoutingModule } from './results-routing.module'
import { ResultsService } from './results.service'
import { SharedModule } from '../shared/shared.module'
import { NgModule } from '@angular/core'
import { FacetFilterModule } from '../libs/facets/facet-filter/facet-filter.module'
import { FacetsModule } from '../shared/facets/facets.module'
import { ButtonRowLayoutModule } from '../libs/button-row-layout/button-row-layout.module'
import { ButtonIconComponentModule } from '../libs/button-icon/button-icon.module'
import { ResultWidgetModule } from '../shared/result-widget/result-widget.module'
import { ResultComponent } from './result/result.component'
import { FiltersModule } from '../libs/filters/filters.module'
import { NoResultsModule } from '../libs/no-results/no-results.module'
import { AnalyticsModule } from '../shared/analytics/analytics.module'
import { ResultsListComponent } from './results-list/results-list.component'
import { ResultsListViewComponent } from './results-list/results-list-view/results-list-view.component'
import { ResultsListResolver } from './results-list/results-list.resolver'
import { ErrorModule } from '../libs/error/error.module'
import { EventCardModule } from '../libs/list-items/event-card/event-card.module'
import { CustomLinkModule } from '../libs/custom-link/custom-link.directive.module'
import { ElementIsVisibleModule } from '../libs/element-is-visible/element-is-visible.module'
import { EventListControlsModule } from '../libs/events/components/event-list-controls/event-list-controls.module'
import { ResultsAnalyticsService } from './results-analytics.service'

@NgModule({
  imports: [
    SharedModule,
    ResultsRoutingModule,
    ResultWidgetModule,
    FacetsModule,
    FacetFilterModule,
    ButtonIconComponentModule,
    ButtonRowLayoutModule,
    FiltersModule,
    NoResultsModule,
    AnalyticsModule,
    ErrorModule,
    EventCardModule,
    CustomLinkModule,
    ElementIsVisibleModule,
    EventListControlsModule
  ],
  exports: [ResultComponent],
  declarations: [ResultComponent, ResultsListComponent, ResultsListViewComponent],
  providers: [ResultsService, ResultsListResolver, ResultsAnalyticsService]
})
export class ResultsModule {}
